// Copyright (C) 2023 Toitware ApS. All rights reserved.
// Use of this source code is governed by an MIT-style license that can be
// found in the LICENSE file.

import { ReactComponent as ChevronRight } from "../assets/images/chevron-right.svg";
import { ReactComponent as Copy } from "../assets/images/copy.svg";
import { ReactComponent as Empty } from "../assets/images/empty-packages.svg";
import { ReactComponent as ExternalLink } from "../assets/images/external-link.svg";
import { ReactComponent as FileText } from "../assets/images/file-text.svg";
import { ReactComponent as Link } from "../assets/images/link.svg";
import { ReactComponent as Linkedin } from "../assets/images/linkedin.svg";
import { ReactComponent as Menu } from "../assets/images/menu.svg";
import { ReactComponent as Package } from "../assets/images/package.svg";
import { ReactComponent as Reddit } from "../assets/images/reddit.svg";
import { ReactComponent as Search } from "../assets/images/search.svg";
import { ReactComponent as Star } from "../assets/images/star.svg";
import { ReactComponent as Tag } from "../assets/images/tag.svg";
import { ReactComponent as TheToitLogo } from "../assets/images/toit-logo.svg";
import { ReactComponent as TheTpkgLogo } from "../assets/images/toit-package-registry-logo.svg";
import { ReactComponent as Twitter } from "../assets/images/twitter.svg";
export const SearchIcon = Search;
export const ExternalLinkIcon = ExternalLink;
export const FileTextIcon = FileText;
export const PackageIcon = Package;
export const TagIcon = Tag;
export const MenuIcon = Menu;
export const StarIcon = Star;
export const CopyIcon = Copy;
export const ToitLogo = TheToitLogo;
export const TpkgLogo = TheTpkgLogo;
export const TwitterLogo = Twitter;
export const LinkedinLogo = Linkedin;
export const RedditLogo = Reddit;
export const EmptyPackages = Empty;
export const ChevronRightIcon = ChevronRight;
export const LinkIcon = Link;
